<div class="tab" :class="(active == 'true') ? 'active' : ''"><slot></slot></div>